import AppHeader from '../../../components/AppHeader';
import InputSearch from '../../../components/InputSearch';
import Loader from '../../../components/Loader';
import NoData from '../../../components/NoData';
import OpacityAnimation from '../../../components/OpacityAnimation';
import Sidebar from '../../../components/Sidebar';
import Transitions from '../../../components/Transition';
import AllQrCodesModal from './components/AllQrCodesModal';
import DeleteModal from './components/DeleteModal';
import List from './components/List';
import ListHeader from './components/ListHeader';
import QrCodeModal from './components/QrCodeModal';
import useVehicles from './useVehicles';

export default function Vehicles() {
  const {
    // userProfile,
    isLoading,
    companyCode,
    companyName,
    vehicles,
    apiFetched,
    searchTerm,
    handleChangeSearchTerm,
    filteredVehicles,
    setAllQrCodesModalShow,
    handleTryAgain,
    allQrCodesModalShow,
    roles,
    areQrCodesDownloading,
    downloadAllQrCodes,
    handleOpenVehicleQrCodeModal,
    handleOpenDeleteVehicleModal,
    vehicleBeingDeleted,
    deleteModalShow,
    setDeleteModalShow,
    vehicleQrCodeBeingShow,
    vehicleQrCodeModalShow,
    setVehicleQrCodeModalShow,
    allQrCodesRef,
    downloadQrCode,
    qrCodeRef,
    isDownloadingQrCode,
    deleteVehicle,
  } = useVehicles();

  const doesListExists = (vehicles?.length > 0 && !isLoading && apiFetched) || (!!vehicles && !isLoading && apiFetched);
  const hasVehicles = (vehicles?.length > 0 && filteredVehicles?.length !== 0 && apiFetched) || (!vehicles && apiFetched);
  const isSearchEmpty = filteredVehicles?.length === 0 && apiFetched && !isLoading && hasVehicles;
  const doesntHaveVehicles = (vehicles?.length === 0 && apiFetched && !isLoading) || (!vehicles && apiFetched && !isLoading);
  // const hasFilteredVehicles = vehicles.length > 0 && apiFetched && filteredVehicles?.length !== 0;

  return (
    <>
      <AppHeader isCompanySelectedDisabled={false} />
      <Sidebar active="Vehicles" />
      <Transitions>
        <Loader isLoading={isLoading} />

        {!!companyCode && (
          <>
            {doesListExists && !doesntHaveVehicles && (
              <OpacityAnimation delay={0.1}>
                <InputSearch
                  searchTerm={searchTerm}
                  handleChangeSearchTerm={handleChangeSearchTerm}
                  placeholder="Pesquisar veículo"
                />
              </OpacityAnimation>
            )}

            {!isLoading && (
              <OpacityAnimation delay={0.1}>
                <ListHeader
                  entity={vehicles}
                  apiFetched={apiFetched}
                  filteredEntity={filteredVehicles}
                  hasVehicles={hasVehicles}
                  linkPath="/vehicles/new"
                  entityString={{ singular: 'veículo', plural: 'veículos' }}
                  setAllQrCodesModalShow={setAllQrCodesModalShow}
                />
              </OpacityAnimation>
            )}

            {hasVehicles && (
              <List
                filteredVehicles={filteredVehicles}
                roles={roles}
                handleOpenVehicleQrCodeModal={handleOpenVehicleQrCodeModal}
                handleOpenDeleteVehicleModal={handleOpenDeleteVehicleModal}
              />
            )}

            {isSearchEmpty && (
              <NoData
                icon="searchNotFound"
                label={(
                  <>
                Nenhum resultado foi encontrado para
                    {' '}
                    <strong>{searchTerm}</strong>
                  </>
                )}
              />
            )}

            {doesntHaveVehicles && (
              <NoData
                icon="emptyBox"
                label={(
                  <>
                Esta empresa não tem nenhum veículo cadastrado, clique no botão
                    {' '}
                    <strong>Novo Veículo</strong>
                    {' '}
                acima para cadastrar seu primeiro!
                  </>
                )}
              />
            )}

            {!apiFetched && !isLoading && (
              <NoData
                icon="sad"
                label={(
                  <>
                Ocorreu um erro ao obter os veiculos.
                    <button type="button" onClick={handleTryAgain}>Tentar Novamente</button>
                .
                  </>
                )}
              />
            )}

            {hasVehicles && !isLoading && (
              <>
                <AllQrCodesModal
                  allQrCodesModalShow={allQrCodesModalShow}
                  companyName={companyName}
                  setAllQrCodesModalShow={setAllQrCodesModalShow}
                  downloadQrCodes={downloadAllQrCodes}
                  exportRef={allQrCodesRef}
                  areQrCodesDownloading={areQrCodesDownloading}
                  vehicles={vehicles}
                />

                <QrCodeModal
                  vehicleQrCodeModalShow={vehicleQrCodeModalShow}
                  companyName={companyName}
                  setVehicleQrCodeModalShow={setVehicleQrCodeModalShow}
                  downloadQrCode={downloadQrCode}
                  exportRef={qrCodeRef}
                  isDownloadingQrCode={isDownloadingQrCode}
                  vehicleQrCodeBeingShow={vehicleQrCodeBeingShow}
                />

                <DeleteModal
                  deleteModalShow={deleteModalShow}
                  vehicleBeingDeleted={vehicleBeingDeleted}
                  setDeleteModalShow={setDeleteModalShow}
                  deleteVehicle={() => deleteVehicle()}
                />
              </>
            )}
          </>
        )}

        {(!companyCode) && (
          <NoData
            icon="companyInterrogation"
            label={(
              <>
              Selecione uma empresa para visualizar os veículos.
              </>
            )}
          />
        )}

      </Transitions>
    </>
  );
}
